
<div class="row">
  <div class="col-sm-12 col-xl-9 px-3">
    <hr class="mb-1 mt-0 text-black">
    <div class="mb-4">
      <span class="h4">Maintenance</span>
      <app-expand-collapse-button [targetSectionId]="'maintenanceExpandCollapse'"></app-expand-collapse-button>
    </div>
  </div>
</div>
<app-expand-collapse-section [sectionId]="'maintenanceExpandCollapse'" [isOpen]="true">
  <div class="mb-4">
    <div class="row">
      <div class="col-sm-12 col-xl-9">
        <app-spinner [show]="isLoading" [center]="true"></app-spinner>
        <p class="text-danger small lh-sm mt-1" *ngIf="errorOccurred">An error occurred while getting the list of maintenance items.</p>
        <ng-container *ngIf="!isLoading && !errorOccurred">
          <p *ngIf="maintenances.length === 0" class="pb-0">
            No maintenance records were found for this vehicle.
          </p>
          <div *ngIf="maintenances.length > 0" class="position-relative table-responsive">
            <table class="table table-sm table-striped table-hover table-bottom-border-inherit lh-md">
              <thead>
              <tr>
                <th>Date of Maintenance</th>
                <th>KMs at this Date</th>
                <th>Maintenance Term</th>
                <th>Max Term KMs</th>
                <th>Max KMs</th>
                <th>User Entering Maintenance</th>
                <th>Due Date</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let maintenance of maintenances">
                <td>{{ maintenance.date }}</td>
                <td>{{ maintenance.kms.toLocaleString() }}</td>
                <td>{{ maintenance.term.description }}</td>
                <td>{{ maintenance.maxKms }}</td>
                <td>{{ (maintenance.maxKms + maintenance.kms).toLocaleString() }}</td>
                <td>{{ maintenance.userEnteringMaintenanceSchedule }}</td>
                <td>{{ maintenance.dueDate | date:'yyyy-MM-dd' }}</td>
                <td class="text-end py-0">
                  <button
                    type="button"
                    class="btn btn-link text-danger p-0"
                    ngbTooltip="Delete"
                    (click)="openDeleteModal(maintenance)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="feather" width="24" height="24" viewBox="0 0 24 24"
                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="position-absolute top-0 start-0 w-100 h-100" [ngClass]="{'d-none': !isRefreshing}">
              <div class="w-100 h-100 bg-white opacity-65"></div>
              <div class="position-absolute top-50 start-50 translate-middle">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-outline-primary position-relative mb-3" type="button" (click)="openCreateModal()">
            Add Maintenance...
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</app-expand-collapse-section>